<template>
  <div class="yealuck-2023-result-base">
    <div class="result-area">
      <h1 class="result_title" v-html="packageInfo.result.title"></h1>
      <div class="block-greetings">
        <img class="fuki-thum" :src="packageInfo.result.thumbnail" :alt="packageInfo.info.name">
        <p class="fuki-body" v-html="packageInfo.result.description"></p>
      </div>

        <div class="block-profile" v-if="profBirthdayStr && profNicknameStr">
          <h2>あなたの情報</h2>
          <span class="birthday" v-if="profBirthdayStr">{{profBirthdayStr}}</span>
          <span class="nickname" v-if="profNicknameStr">{{profNicknameStr}}</span>
        </div>

      <div class="block-result-list">
        <result-item
          v-for="(item, idx) in resultList"
          :key="idx"
          :is-free="isFreeResult"
          :result-data="item"
          @btn-click="onInducePurchaseClick(`result_item_${idx}`)"
        />
      </div>
    </div>
      <!-- 一部無料の場合の表示 -->
      <div class="block-induce-purchase" v-if="isFreeResult">
        <img :src="`${imgPath}result/img_induce_purchase.png`" alt="">
        <basic-button
          class="btn-induce-purchase"
          @btn-click="onInducePurchaseClick"
          :has-shadow="false"
        >続きを見る（有料）</basic-button>
      </div>
      <!-- 有料メニューの場合の場合 -->
      <div class="block-induce-subscr" v-else>
        <div class="sec-fuki">
          <p class="fuki-body-pink" v-html="packageInfo.result.bottomFukiMessage"></p>
          <img class="fuki-img-pink" :src="packageInfo.result.underThumbnail" :alt="packageInfo.info.name">
        </div>
        <div class="sec-menus">
        <div
          class="menu-item"
          v-for="(item, idx) in subscrMenusList"
          :key="idx"
        >
          <div class="menus-wrap">
            <h4 class="menus-wrap-title" v-html="item.title"></h4>
            <p class="menus-wrap-text" v-html="item.text"></p>
            <div class="blur_textarea" v-if="!subscriptionFlg">
              <basic-button
                class="btn-induce-subscr"
                @btn-click="onInduceSubscClick(item)"
                :bg-string="bgStrSubscrBtn"
                :has-shadow="false"
              >続きを見る（月額￥528）</basic-button>
              <span class="menus-wrap-notice">※ここから先は月額登録でご覧いただけます</span>
            </div>
          </div>
        </div>
      </div>
        <div class="sec-description">
          <img :src="`${imgPath}result/result_bottom_point.svg`" alt="">
        </div>
        <div class="sec-movie" v-if="!subscriptionFlg">
          <video :src="`${imgPath}result/yearluck2023.mp4`" autoplay loop muted playsinline></video>
        </div>
        <div class="sec-buttons">
          <basic-button
            class="btn-induce-subscr"
            @btn-click="onInduceSubscClick({url: sbscUrl})"
            :bg-string="bgStrSubscrBtn"
            :has-shadow="false"
          >占いTV（月額￥528）に<br>登録してみる</basic-button>
          <basic-button
            class="btn-induce-subscr"
            @btn-click="onReturnTopClick"
            :bg-string="bgStrSubscrBtn"
            :has-shadow="false"
          >2023年の運勢<br>TOPへ戻る</basic-button>
        </div>
      </div>

  </div>
</template>

<script>
import {PACKAGE_INFO} from './data/consts'
import ResultItem from './partials/ResultItem'
import BasicButton from './partials/BasicButton'

export default {
  name: 'Yearluck2023Top',
  components: {BasicButton, ResultItem},
  props: {
    receivedPackageInfo: {
      type: Object,
      required: true,
    },
    receivedSubscResult: {
      type: Array,
    },
    targetAction: {
      type: String,
    },
    targetProfile: {
      type: Object,
    },
    resultList: {
      type: Array,
    },
    sbscUrl: {
      type: String,
    },
    isFree: {
      type: [Number, String],
      default: '0',
    },
    subscriptionFlg: {
      type: Boolean,
      defaut: false,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2023/',
    }
  },
  computed: {
    profBirthdayStr() {
      const mtc = this.targetProfile.birth_date.match(/((?:19|20)\d\d)([0-1]\d)([0-2]\d)/)
      if(!!this.targetProfile
        && this.targetProfile.birth_date
        && this.targetProfile.birth_date.length > 0
        && mtc
      ){
        return `${mtc[1]}年${+mtc[2]}月${+mtc[3]}日生まれ`
      }
    },
    profNicknameStr() {
      return !!this.targetProfile && this.targetProfile.nickname && this.targetProfile.nickname.length > 0 ? `${this.targetProfile.nickname}さん` : null
    },
    bgStrSubscrBtn() {
      return 'linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%)'
    },
    subscrMenusList() {
      if(this.receivedSubscResult) {
        return this.receivedSubscResult
      }
    },
    isFreeResult() {
      return +this.isFree > 0
      //確認用
      //return false
    },
    packageInfo() {
      const info = PACKAGE_INFO.find(infoitem => infoitem.info.itemId === +this.receivedPackageInfo.item_id)
      return {
        server: this.receivedPackageInfo,
        ...info,
      }
    },
  },
  mounted() {
    // console.log('targetProfile: %O', this.targetProfile)
    // console.log('resultList: %O', this.resultList)
  },
  methods: {
    onInducePurchaseClick(idx) {
      const params = [
        { key: '_token', value: this.csrfToken, },
        { key: 'birth_date', value: this.targetProfile.birth_date, },
        { key: 'nickname', value: this.targetProfile.nickname, },
      ]
      const frm = document.createElement('form')
      frm.action = this.targetAction
      frm.method = 'post'
      document.body.appendChild(frm)

      params.forEach(item => {
        const input = document.createElement('input')
        input.name = item.key
        input.value = item.value
        frm.appendChild(input)
      })

      setTimeout(() => frm.submit(), 0)
    },
    onInduceSubscClick() {
      location.href = this.sbscUrl
    },
    onReturnTopClick() {
      location.href = '/2023_luck'
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.yealuck-2023-result-base{
  background-image: url('/static/img/yearluck/y2023/bg_main.svg');
  background-size: 100%;
  background-color: #f8edb6;
  margin: 0;
  padding-top: 24px;
  @include mq('w580'){
    margin-bottom: -40px;
  }
}
  .result-area{
    padding: 0 20px;
  }


.result_title{
  background: url('/static/img/yearluck/y2023/result/result_title.png') no-repeat;
  background-size: 100%;
  color: #fff;
  font-size: 15px;
  text-align: center;
  margin: 0;
  padding: 10px;
  padding-top: 3.5vw;
  min-height: 90px;
  @include mq('w320'){
    font-size: 18px;
    margin: 0 0 26px;
  }
  @include mq('w580'){
    height: 129px;
    padding: 20px;
    font-size: 25px;
  }
}
.block-greetings{
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.fuki-body{
    //background: url(/static/img/yearluck/y2023/result/result_fukidashi.svg) no-repeat;
    margin: 0;
    padding: 15px;
    //padding-left: 30px;
    color: #333;
    font-weight: 300;
    font-size: 13px;
    line-height: 20px;
    //min-height: 61vw;
    position: relative;
    background-color: white;
    margin-left: 15px;
    border-radius: 10px;
    &::before{
      content: "";
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 12px 6px 0;
      border-color: transparent #fff transparent transparent;
      position: absolute;
      top: 50%;
      left: -10px;
    }

  @include mq('w580'){
    height: 293px;
    font-size: 18px;
    line-height: 1.8em;
    padding: 36px;
    //padding-left: 64px;
  }
}
.fuki-thum{
  width:104px;
  height: 128px;
  @include mq('w580'){
    width: 153px;
    height: auto;
  }
}
.block-profile{
  background: url('/static/img/yearluck/y2023/result/result_name.png') no-repeat;
  text-align: center;
  background-size: 100%;
  margin-bottom: 24px;
  padding: 0 11px;

  padding-top: 2.5vw;
  height: 28vw;
  @include mq('w320'){
    padding-top: 4.5vw;
  }
  @include mq('w580'){
    height: 167px;
    padding: 40px;
  }
  h2{
    color:#fff;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    margin-bottom: 8px;
    @include mq('w580'){
      font-size: 22px;
      margin-bottom: 16px;
    }
  }
  span{
    display: block;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #333233;
    @include mq('w580'){
      font-size: 18px;
    }
  }
}
.block-induce-subscr {
  background: #fff;
  padding:0 20px;
}
.sec-fuki{
 display: flex;
 margin-bottom: 15px;
 padding-top:40px;
 align-items: center;
}

.fuki-body-pink{
  //background: url("/static/img/yearluck/y2023/result/result_fukidashi_pink.svg") no-repeat;
  margin: 0;
  padding: 17px;
  color: #333233;
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  margin-right: 33px;
  position: relative;
  border-radius: 10px;
  background-color: #fff5f8;
  &::before{
    content: "";
    width: 0;
    height: 0;
    right: -17px;
    top: 43%;
    border-style: solid;
    border-width: 11px 0 11px 22px;
    border-color: transparent transparent transparent #fff5f8;
    position: absolute;
  }
  @include mq('w580'){
    padding: 25px;
    background-size: 100%;
    font-size: 17px;
    //padding-right: 61px;
    line-height: 26px;
  }
}
.fuki-img-pink{
  width:104px;
  height: 128px;
  margin-left: -10px;
  @include mq('w580'){
    width: 169px;
    height: auto;
  }
}
.menus-wrap{
  background: #fff5f8;
  border: 1px solid #333233;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 14px;
}

.menus-wrap-title{
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #ff7497;
  margin: 0;
  margin-bottom: 10px;
}
.menus-wrap-text{
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #32373f;
  margin: 10px;
}
.menus-wrap-notice{
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #303030;
  display: block;
  margin-top:8px;
}
.sec-description{
  margin-top:40px;
  margin-bottom: 24px;
  img{
    width:100%;
  }
}
.sec-movie{
  margin: 0 auto 24px;
  width: 75%;
  @include mq('w580'){

    width: 50%;
  }

}
.sec-buttons{
  span{
    margin-bottom: 16px;
  }
}

.btn-induce-subscr {
  &.basic-button {
    // font-size: 14px;
  }
}

.block-induce-purchase{
  margin: 0 20px;
  margin-top: 24px;
  padding-bottom: 80px;
  img{
    width:100%;
    margin-bottom: 24px;
  }
}

video{
  width: 100%;
}

.blur_textarea{
  background: url('/static/img/yearluck/y2023/result/blur_text.png');
  height: 144px;
  background-size: contain;
  padding: 40px 8px;
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/Yearluck2023Result.vue